import { z } from "zod";
import { Id } from "../common/ids.js";
import { Timestamp } from "../common/time.js";
/** Every domain event type (docs/05-api-contracts.md section 14). */
export const EVENT_TYPES = [
    "identity.enterprise.verified.v1",
    "identity.enterprise.suspended.v1",
    "identity.enterprise.reinstated.v1",
    "identity.membership.changed.v1",
    "identity.membership.left.v1",
    "identity.agreement.accepted.v1",
    "identity.user.changed.v1",
    "identity.device.revoked.v1",
    "identity.data-export.requested.v1",
    "directory.contact.accepted.v1",
    "directory.relationship.transferred.v1",
    "messaging.evidence.exported.v1",
    "messaging.entry.appended.v1",
    "files.file.uploaded.v1",
    "files.file.scanned.v1",
    "notifications.requested.v1",
    "audit.chain.broken.v1",
    "catalog.shop.opened.v1",
    "catalog.shop.updated.v1",
    "catalog.shop.bank-account-set.v1",
    "catalog.product.published.v1",
    "catalog.product.updated.v1",
    "catalog.product.unlisted.v1",
    "catalog.product.blocked.v1",
    "catalog.risk-entry.added.v1",
    "trade.inquiry.created.v1",
    "trade.inquiry.declined.v1",
    "trade.inquiry.withdrawn.v1",
    "trade.inquiry.expired.v1",
    "trade.quote.issued.v1",
    "trade.quote.countered.v1",
    "trade.quote.accepted.v1",
    "trade.quote.expired.v1",
    "trade.order.created.v1",
    "trade.schedule-item.due.v1",
    "trade.offline-payment.confirmed.v1",
    "trade.shipment.recorded.v1",
    "trade.shipment.delivered.v1",
    "trade.order.receipt-confirmed.v1",
    "trade.change-order.approved.v1",
    "trade.order.cancelled.v1",
    "trade.order.completed.v1",
    "trade.review.published.v1",
    "trade.review.replied.v1",
    "trade.review.hidden.v1",
    "trade.invoice.issued.v1",
    "payment.connected-account.kyb-approved.v1",
    "payment.connected-account.kyb-revoked.v1",
    "payment.item.held.v1",
    "payment.item.released.v1",
    "payment.item.refunded.v1",
    "payment.instruction.failed.v1",
    "payment.reconciliation.exception-opened.v1",
    "aftersales.case.opened.v1",
    "aftersales.case.agreed.v1",
    "aftersales.case.escalated.v1",
    "aftersales.case.resolved.v1",
    "aftersales.case.closed.v1",
    "operations.ruleset.changed.v1",
    "operations.flag.changed.v1",
];
export const EventActor = z.object({
    type: z.enum(["user", "operator", "system"]),
    id: z.string().nullable(),
});
export const EventTenants = z.object({
    owner: Id.optional(),
    buyer: Id.optional(),
    seller: Id.optional(),
});
/** Builds the schema of one event: the shared envelope around a typed payload. */
export function eventSchema(type, payload) {
    return z.object({
        eventId: z.uuid(),
        type: z.literal(type),
        occurredAt: Timestamp,
        actor: EventActor,
        tenants: EventTenants,
        aggregate: z.object({ type: z.string(), id: Id, version: z.number().int().nonnegative() }),
        causationId: z.uuid().nullable(),
        correlationId: z.uuid(),
        payload,
    });
}
//# sourceMappingURL=envelope.js.map